module.exports = __webpack_public_path__ + "img/certificato-qualità.7299b8e9.png";